// extracted by mini-css-extract-plugin
module.exports =  {"rectBackground":"VerticalBar-module__rectBackground--ypgpY","verticalBarRoot":"VerticalBar-module__verticalBarRoot--1PlGu"};